import { useEffect, useRef, useState } from 'react';
import styles from './chatbot.module.css';
import { io } from "socket.io-client"
import axios from 'axios';

function Message({ text, isUser }) {
    return (
        <div className={`${styles.message} ${isUser ? styles.userMessage : styles.botMessage}`}>
            {text}
        </div>
    );
}

export default function Chatbot() {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState('');
    const [isOpen, setIsOpen] = useState(false);
    const msgRef = useRef(null);

    const socket = io();

    const sampleMessages = [
        {
            text: "Hello! How may I assist you today?",
            isUser: false
        }
    ]
    function sendMessage(msg) {
        setMessages([...messages, { text: msg, isUser: true }]);
        setInput('');
        const botResponse = "I'm not functional yet, but I will be soon!";
        setMessages((prevMessages) => [...prevMessages, { text: botResponse, isUser: false }]);
        const msgs = document.querySelector(`.${styles.messages}`);
        
        const api_uri = `${process.env.REACT_APP_LOCAL_API_URI}/api/conversations`

        axios.post(api_uri, {msg}).then(res => {
            console.log(res.data)

        }).catch(err => {

        })



    }
    useEffect(() => {
        msgRef.current?.scrollTo({
            top: msgRef.current.scrollHeight,
            behavior: 'smooth'
        })
    }, [messages])

    useEffect(() => {
        setMessages(sampleMessages);
    }, [])
    useEffect(() => {
        // console.log(isOpen ? "opened" : "closed")

        // socket.on("connect", () => {
        //     console.log(socket.id)
        // })
        // socket.on("disconnect", ()=>{
        //     console.log(socket.id)
        // })


    }, [isOpen])


    return (
        <div className={styles.chatbot}>
            <div className={styles.chatbotHeader} onClick={() => setIsOpen(!isOpen)}>

                {isOpen ? <p>Chat with us</p> :
                    <svg xmlns="http://www.w3.org/2000/svg" className={styles.toggleButton} fill="currentColor" viewBox="0 0 16 16">
                        <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" />
                    </svg>}
                {/* <span className={styles.toggleButton}>{isOpen ? '−' : '+'}</span> */}
            </div>
            {isOpen && (
                <div className={styles.chatbotBody}>
                    <div className={styles.messages} ref={msgRef}>
                        {messages.map((msg, index) => (
                            <div key={index} className={`${styles.messageContainer} ${msg.isUser ? styles.user : styles.bot}`}>
                                <Message text={msg.text} isUser={msg.isUser} />
                            </div>
                        ))}

                    </div>
                    <form onSubmit={(e) => {
                        e.preventDefault();
                        sendMessage(input);
                        console.log('User input:', input);
                    }}>
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            placeholder="Type your message..."
                        />
                    </form>
                </div>
            )}
        </div>
    );
}